class LocalizationFormController extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  connectedCallback () {
    super.connectedCallback()

    this.appendParamsToReturnUrl()
  }

  appendParamsToReturnUrl () {
    if (!this.returnUrlInput) {
      return
    }

    this.returnUrlInput.value = `${this.returnUrlInput.value}${window.location.search}`
  }

  /** @type {HTMLFormElement} */
  get form () {
    return this.closest('form')
  }

  /** @type {HTMLInputElement} */
  get returnUrlInput () {
    return this.form.querySelector('input[name="return_to"]')
  }
}

if (!window.customElements.get('localization-form-controller')) {
  window.customElements.define(
    'localization-form-controller',
    LocalizationFormController,
  )
}
